<template>
  <el-card
    id="leaderMeetingsCard"
    class="clear-card leaderMeetings"
    shadow="hover"
    :body-style="{
      height: 'calc(100% - 56px)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    }"
  >
    <div
      slot="header"
      class="header defaultCursor"
    >
      <span>
        {{ $t('coach.leader.meeting.title') }}
      </span>
    </div>
    <div
      class="content"
      :class="meeting.includes('No') ? 'noData' : 'inData'"
    >
      <span
        v-if="meeting.includes('Next')"
        class="noMeeting"
      >
        {{ $t('coach.leader.meeting.noData') }}
      </span>
      <span
        v-else
        class="inMeeting"
      >
        {{ meeting }}
      </span>
    </div>
  </el-card>
</template>

<script>
export default {
  props: {
    meeting: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
  #leaderMeetingsCard {
    text-align: center;

    .noMeeting {
      font-weight: normal;
      color: #c4c4c4;
    }

    .inMeeting {
      font-size: 20px;
    }

    .header {
      font-weight: bold;
    }

    .content {
      font-weight: bold;

      &.noData {
        box-sizing: border-box;
        color: #c4c4c4;
      }
    }
  }
</style>

<style lang="scss">
  #leaderMeetingsCard {
    .el-card__body {
      height: 100%;
      box-sizing: border-box;
    }
  }
</style>
